export const createFormFieldNames = <
  TType extends Record<string, string>,
  TName extends string,
>(
    data: TType,
    name: TName,
  ): Record<keyof TType, TName> => Object.entries(data)
    .reduce(
      (acc, [propertyKey, propertyValue]) => ({
        ...acc,
        [propertyKey]: `${name}.${propertyValue}`,
      }),
      {} as Record<keyof TType, TName>,
    );
